// removed by extract-text-webpack-plugin
module.exports = {"back":"B6yr0"};


//////////////////
// WEBPACK FOOTER
// ./components/BackButton/styles.scss
// module id = 695
// module chunks = 0